import React from 'react';
import { close_icon, confirmWarning } from '../../assets/images';

const ConfirmModal = ({ visible, heading, liner = '', handler, closeHandler, confirmIcon }) => {
  const icon = confirmIcon ?? confirmWarning
  return (
    <div
      className={`fixed z-30 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
      aria-labelledby='modal-title'
      role='dialog'
      aria-modal='true'
    >
      <div className='flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
        <div
          className='fixed inset-0 bg-gray-900 bg-opacity-25 transition-opacity'
          aria-hidden='true'
          onClick={closeHandler}
          style={{backgroundColor: '#00000080'}}
        ></div>

        <span className='hidden sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
          &#8203;
        </span>

        <div 
          className='inline-block align-bottom bg-white rounded-lg pt-6 text-left overflow-hidden transform duration-75 sm:my-8 sm:align-middle'
          style={{ width: 773, height: 216 }}
        >
          <img src={close_icon} alt='closeIcon' className='cursor-pointer absolute right-8 z-10 transform group-hover:transition-colors ease-in-out duration-100 hover:rotate-90' onClick={closeHandler} />
          <div className='h-full w-full relative pt-2' style={{ gap: '0.7rem' }}>
            <div className='flex items-start gap-4 px-8'>
              <img src={icon} alt='warning icon' />
              <div>
                <h1 className={`'text-gray-700 font-bold text-lg mb-0 leading-none' ${liner === '' ? 'mt-2' : ''}`}>{heading}</h1>
                <p className='text-gray-600 text-base mt-2'>{liner}</p>
              </div>
            </div>
            <div className='bg-gray-100 p-4 w-full gap-3 flex flex-row-reverse absolute bottom-0'>
              <button className='rounded-md border bg-blue-600 hover:bg-blue-500 text-white font-semibold py-3 px-5' onClick={handler}>Yes</button>
              <button className='rounded-md border border-gray-200 hover:bg-blue-50 bg-white text-blue-600 font-semibold py-3 px-5' onClick={closeHandler}>No</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal
